"use client";

import { Menu, CircleUser } from "lucide-react";
import React, { useCallback } from "react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Sheet, SheetTrigger, SheetContent } from "@/components/ui/sheet";
import { useRouter } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import * as m from "@/paraglide/messages";

import { SearchDialog } from "./seachDialog";
import { ThemeSwitcher } from "./theme-switcher";
import LanguageSwitcher from "../language-dropdown";
import MobileSidebar from "../mobileSidebar";
import NotificationsDropdown from "../notfication-dropdown";

const Header = () => {
  const { push } = useRouter();

  const onLogout = useCallback(
    () => window.dispatchEvent(new CustomEvent("logoutNow")),
    [],
  );

  return (
    <header
      className={cn(
        "flex  items-center gap-4 md:border-b-0 border-b -mt-2 -ms-2 py-2 md:py-0 md:w-fit w-screen md:px-0 px-2 md:mb-0 mb-4",
      )}
    >
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="outline" size="icon" className="shrink-0 lg:hidden">
            <Menu className="h-5 w-5" />
            <span className="sr-only">{m.toggle_nav()}</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="p-0 ">
          <MobileSidebar />
        </SheetContent>
      </Sheet>
      <div className="flex w-fit items-center gap-3 ml-auto md:gap-2 lg:gap-4 justify-end">
        <div className="relative">
          <SearchDialog />
        </div>
        {/* Language dropdown */}
        <LanguageSwitcher />
        {/* Theme Converter */}
        <ThemeSwitcher />
        {/* Notification dropdown */}
        <NotificationsDropdown />
        {/* User dropdown */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="secondary" size="icon" className="rounded-full">
              <CircleUser className="h-5 w-5" />
              <span className="sr-only">{m.toggle_user_menu()}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>{m.my_account()}</DropdownMenuLabel>
            <DropdownMenuSeparator />

            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() => push("/settings")}
            >
              {m.settings()}
            </DropdownMenuItem>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() => push("/settings/billing")}
            >
              {m.manage_sub()}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="cursor-pointer" onClick={onLogout}>
              {m.logout()}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default Header;
